import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * The one class-name helper, as in every shadcn/ui component.
 *
 * It used to be `extendTailwindMerge` with the console's six sizes listed by
 * hand, because the scale had names of its own (`text-sub`, `text-logo`) and
 * `tailwind-merge` ships with the list of the sizes *Tailwind* has. Anything
 * outside that list is not a size to it, so `cn("text-sub", "text-muted")` read
 * as two classes from one group and kept the later — the size vanished, and
 * only where a component merged the pair through `cn()` rather than writing it
 * as a string. The same two classes behaving differently depending on how they
 * were spelled.
 *
 * Putting the scale on Tailwind's own names removes the cause rather than the
 * symptom: `text-lg` is a size to `tailwind-merge` without being told. The list
 * that had to be kept in step with `styles.css` is gone, and
 * `test/type-scale.test.js` now checks the property that mattered — that a size
 * survives being merged next to a colour — instead of comparing two lists.
 */
export const cn = (...inputs: ClassValue[]) => twMerge(clsx(inputs));
